import * as React from 'react';

export const EyeOff = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.98 8.223A10.477 10.477 0 002.25 12c1.5 4.5 5.25 7.5 9.75 7.5 2.042 0 3.97-.497 5.625-1.377M6.42 6.429C7.983 5.322 9.926 4.5 12 4.5c4.5 0 8.25 3 9.75 7.5a10.51 10.51 0 01-4.362 5.263M15 12a3 3 0 11-6 0 3 3 0 016 0zM3 3l18 18"
    />
  </svg>
);

export default EyeOff;
